const getDateFromString = (dateString) => {
  try {
    if (!dateString) {
      throw new Error("Date string is empty");
    }
    const splitDate = dateString.split("/");
    const date = new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
    return date;
  } catch (e) {
    console.log(e, dateString);
    return "";
  }
};

export default getDateFromString;
